const REGIONS = ['us', 'cn'];

/**
 * ff.com pages under /us or /cn whose address has no counterpart in the other
 * region: /us/about without /cn/about. Returns path → the one region it's in.
 */
export function onlyInOneRegion(paths: string[]): Map<string, string> {
  const byRest = new Map<string, Map<string, string>>();
  paths.forEach((path) => {
    const parts = String(path || '').split('/');
    const region = parts[1];
    if (!REGIONS.includes(region)) return;
    const rest = `/${parts.slice(2).join('/')}`.replace(/\/+$/, '') || '/';
    if (!byRest.has(rest)) byRest.set(rest, new Map());
    (byRest.get(rest) as Map<string, string>).set(region, path);
  });
  const result = new Map<string, string>();
  byRest.forEach((regions) => {
    if (regions.size === 1) {
      const [region, path] = Array.from(regions.entries())[0];
      result.set(path, region.toUpperCase());
    }
  });
  return result;
}
